import { LogLevel, PublicClientApplication } from '@azure/msal-browser';

const clientId = '58ceda9f-3564-4467-93c6-9f41769feec8'; //This is your client ID

export function getMSALInstance() {
    const msalConfig = {
        auth: {
            clientId: clientId,
            authority: 'https://login.microsoftonline.com/common',
            navigateToLoginRequestUrl: false,
        },
        cache: {
            cacheLocation: 'sessionStorage', // Needed to avoid "User login is required" error.
            storeAuthStateInCookie: true, // Recommended to avoid certain IE/Edge issues.
        },
        system: {
            loggerOptions: {
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            console.error(message);
                            return;
                        case LogLevel.Info:
                            console.info(message);
                            return;
                        case LogLevel.Verbose:
                            console.debug(message);
                            return;
                        case LogLevel.Warning:
                            console.warn(message);
                            return;
                    }
                },
            },
        },
    };

    const publicClientApp = new PublicClientApplication(msalConfig);
    return publicClientApp;
}
